export const requestClass = (qualification) => (dispatch, getState) => {
  dispatch({
    type: "REQUEST_CLASS",
    payload: qualification,
  });
};
